import { render, staticRenderFns } from "./CopyrightService.vue?vue&type=template&id=74db158b&scoped=true&"
import script from "./CopyrightService.vue?vue&type=script&lang=js&"
export * from "./CopyrightService.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightService.vue?vue&type=style&index=0&id=74db158b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db158b",
  null
  
)

export default component.exports